export const HTTP_STATUS_CODE_OK = 200;
export const HTTP_STATUS_ACCESS_DENIED = 403;
export const HTTP_STATUS_UNPROCESSABLE_ENTITY = 422;
export const HTTP_STATUS_CODE_USER_BLOCKED = 423;
export const HTTP_STATUS_CODE_USER_EXISTS = 452;
export const HTTP_STATUS_CODE_USER_DOES_NOT_EXIST = 453;
export const HTTP_STATUS_CODE_INVALID_PASSWORD = 454;
export const HTTP_STATUS_CODE_FORBIDDEN_EMAIL_DOMAIN = 455;
export const HTTP_STATUS_CODE_EMAIL_SUGGESTION = 456;
